module.exports = __webpack_public_path__ + "static/media/V2_22.9e9683a2.png";